import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ErrorService } from '@cosmos/angular/utils';
import { catchError, map, Observable } from 'rxjs';
import { environment } from '../../../../../../environments/environment';

export interface RawCsvRow {
  _id: string;
  filename: string;
  channelId: number;
  // 'unresolved' rows (parse failure / unknown device UID) never appear here —
  // this endpoint is scoped to one measurement, and 'unresolved' rows have none.
  // Kept in the union for parity with the backend status type.
  status: 'orphan' | 'processed' | 'removed' | 'unresolved';
  createdAt: string;
  processedAt?: string;
  error?: string;
  smartSensorUid?: string;
  linked: boolean;
}

@Injectable({ providedIn: 'root' })
export class IngestedCsvService {
  constructor(private http: HttpClient, private errorService: ErrorService) {}

  getForMeasurement(measurementId: string): Observable<HttpResponse<RawCsvRow[]>> {
    return this.http
      .get<RawCsvRow[]>(`${environment.API_URL}/measurements/${measurementId}/ingested-csv`, { observe: 'response' })
      .pipe(
        map((r) => r),
        catchError((e) => { this.errorService.handleError(e); throw e; }),
      );
  }

  download(measurementId: string, csvId: string): Observable<HttpResponse<Blob>> {
    return this.http
      .get(`${environment.API_URL}/measurements/${measurementId}/ingested-csv/${csvId}/download`, {
        responseType: 'blob',
        observe: 'response',
      })
      .pipe(
        map((r) => r),
        catchError((e) => { this.errorService.handleError(e); throw e; }),
      );
  }

  downloadBulk(measurementId: string, csvIds: string[]): Observable<HttpResponse<Blob>> {
    return this.http
      .post(`${environment.API_URL}/measurements/${measurementId}/ingested-csv/download`, { csvIds }, {
        responseType: 'blob',
        observe: 'response',
      })
      .pipe(
        map((r) => r),
        catchError((e) => { this.errorService.handleError(e); throw e; }),
      );
  }
}
